import {Alert, Button, Checkbox, FormControlLabel, Stack, Typography} from "@mui/material";

const plural = (count, word) => `${count} ${word}${count === 1 ? "" : "s"}`;

export const PhoneNumbersToolbar = ({
  total, duplicateCount, emptyCount, onlyIssues, onOnlyIssuesChange, onRemoveDuplicates, onClear
}) => {
  const invalidCount = duplicateCount + emptyCount;

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{mb: 1}}>
        <Typography fontWeight={500} fontSize={14}>{plural(total, "phone number")}</Typography>
        <Stack direction="row" gap={1} alignItems="center">
          {invalidCount > 0 &&
            <FormControlLabel
              control={<Checkbox size="small" checked={onlyIssues} onChange={(e) => onOnlyIssuesChange(e.target.checked)}/>}
              label={<Typography fontSize={13}>Show only issues</Typography>}
            />
          }
          {duplicateCount > 0 &&
            <Button size="small" color="warning" onClick={onRemoveDuplicates}>Remove duplicates</Button>
          }
          {total > 0 &&
            <Button size="small" color="error" onClick={onClear}>Clear all</Button>
          }
        </Stack>
      </Stack>

      {invalidCount > 0 &&
        <Alert severity="warning" sx={{mb: 1}}>
          {duplicateCount > 0 && `${plural(duplicateCount, "duplicate number")}. `}
          {emptyCount > 0 && `${plural(emptyCount, "empty row")}. `}
          Fix or remove them before saving the campaign.
        </Alert>
      }
    </>
  )
}
